import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'

export function mapDatabasePropertyResponseInstance(databaseProperty: IToJson<IDatabasePropertyResponseInstance>): IDatabasePropertyResponseInstance {
  return databaseProperty
}
